import { connect } from 'react-redux'
import UI from './UI'
import { AlgeriaId } from 'constants/'

const mapStateToProps = ({ referential }) => ({
  isAlgeria: referential?.CountryDetails?.Id === AlgeriaId
})

export default connect(mapStateToProps, null)(UI)
